module.exports = __webpack_public_path__ + "img/four4Blue.caa1b1e5.jpg";